import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { Translation } from '../../graphql/generated/graphql'

import { actionTypes } from './types'

export const name = 'configuration'

export type ConfigurationState = {
  defaultLocale: string
  locale: string | null
  wordings: { [key: string]: Array<Translation> } | null
}

//
// Initial state
//

const initialState: ConfigurationState = {
  defaultLocale: 'fr',
  locale: null,
  wordings: null,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setWordings: (state: ConfigurationState, action: actionTypes.setWordings) => {
      const { wordings } = action.payload
      state.wordings = wordings
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[name]
const defaultLocale = (state: RootState) => root(state).defaultLocale
const locale = (state: RootState) => root(state).locale
const labels = (state: RootState) => root(state).wordings

export const selectors = {
  defaultLocale,
  locale,
  labels,
}
